import React from "react";
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { useNavigate , Link} from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import mainBg from "../../assets/img/bg-ai-02.jpg";
import aiImg from "../../assets/img/ai-WISaicc.png";
import aiIcon01 from "../../assets/img/icon-ai05.png";
import aiIcon02 from "../../assets/img/icon-ai06.png";
import aiIcon03 from "../../assets/img/icon-ai07.png";
import aiIcon04 from "../../assets/img/icon-ai08.png";
import fwImg from "../../assets/img/fw-wisaicc.png";

function WISaicc() {
    // 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';

  //이미지 클릭
  const imgClick = () => {
    const img = new Image();
    img.src = fwImg;

    img.onload = () => {
      // 이미지 실제 원본 크기 가져오기
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;
      
      // 창 크기를 1200px로 고정하고 반응형으로 조정, 높이는 이미지 비율에 맞춤
      const w = Math.min(1200, window.innerWidth * 0.94);
      const aspectRatio = imgHeight / imgWidth;
      const h = w * aspectRatio;

      // 창을 현재 모니터 중앙에 위치시키기 (듀얼모니터 환경 고려)
      const currentScreenLeft = window.screen.availLeft || 0;
      const currentScreenWidth = window.screen.availWidth;
      const left = currentScreenLeft + (currentScreenWidth - w) / 2;
      const top = (window.screen.height - h) / 2;

      // HTML 페이지를 만들어서 이미지와 파비콘을 함께 표시
      const htmlContent = `
        <!DOCTYPE html>
        <html lang="ko">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>WISaicc 프레임워크</title>
          <style>
            body {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
              overflow: auto;
            }
            .image-container {
              width: 100%;
              height: 100%;
              text-align: center;
              padding: 0;
              overflow: visible;
            }
            .image-container img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              cursor: pointer;
              transition: transform 0.3s ease;
              transform-origin: top left;
            }
            .image-container img.zoomed {
              cursor: zoom-out;
            }
          </style>
          <script>
            function toggleZoom(img) {
              if (img.classList.contains('zoomed')) {
                // 축소: 원본 크기로
                img.style.transform = 'scale(1.0)';
                img.classList.remove('zoomed');
              } else {
                // 확대: 1.5배 또는 이미지 원본 크기 제한
                const imgNaturalWidth = ${imgWidth};
                const containerWidth = ${w};
                const scale1_5 = 1.5;
                const scale1_5Width = containerWidth * scale1_5;
                
                // 1.5배 크기가 이미지 원본보다 크면 원본 크기로, 작으면 1.5배로
                let finalScale;
                if (scale1_5Width > imgNaturalWidth) {
                  finalScale = imgNaturalWidth / containerWidth;
                } else {
                  finalScale = scale1_5;
                }
                
                img.style.transform = 'scale(' + finalScale + ')';
                img.classList.add('zoomed');
              }
            }
          </script>
        </head>
        <body>
          <div class="image-container">
            <img src="${fwImg}" alt="WISaicc 프레임워크" onclick="toggleZoom(this)" />
          </div>
        </body>
        </html>
      `;

      // 새 창 열기 - 이미지 비율에 맞춘 높이로
      const newWindow = window.open(
        "",
        "_blank",
        `width=${w},height=${h},left=${left},top=${top},resizable=yes,scrollbars=yes,menubar=no,toolbar=no,location=no,status=no`
      );

      if (newWindow) {
        newWindow.document.write(htmlContent);
        newWindow.document.close();
      }
    };
  };

  //파일다운로드
    const downloadFile = async () => {
    const response = await fetch("/download/brochure");
    const blob = await response.blob();
  
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "위피아_AI솔루션.pdf";
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };



    return (<>
	<main className="page-wrapper">
		{isAdmin ? <AdminHeader /> : <Header />}
      {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
            <span className="ko">AI 콜센터(AICC)와 챗봇</span>
						<h2>WISaicc</h2>
						<p>AICC(AI 컨택 센터, AI Contact Center) 솔루션은 고객 상담 및 컨택센터 운영을 자동화하고 효율성을 높이는 시스템입니다.<br />고객 응대, 상담 분석, 업무 자동화 등을 지원합니다.</p>
					</div>
					<SubMenu />
			</section>

			<section className="container-auto sec-my ai-business-wrap">
        <section className="aiCont">
          <h4 className="title">
            <span>연관 솔루션</span>
          </h4>

          <h5 className="title">기업·기관의 비즈니스 프로세스를 혁신하세요!</h5>
          <p className="text">조직 내 모든 유형의 <span className="blue">AI 서비스와 데이터</span>를 손쉽게 연결하고, 통합된 환경에서 안전하게 운영·확장할 수 있는 엔터프라이즈 AI 허브이자, 업무 혁신의 디지털 플랫폼입니다.<br/>
          <span className="blue">복수의 AI 엔진, 멀티모달 데이터, 외부/기존 IT 시스템 및 다양한 채널</span>과의 연계를 필요로 하는 기업·기관에 특히 적합합니다.<br/>
          플랫폼 도입 시 즉각적 디지털 전환 효과와 <span className="blue">지속적 AI 확장 기반</span>을 함께 확보할 수 있습니다.</p>
          <ul className="link-wrap">
            <li> <Link to="/WISplatform">WISplatform <i></i></Link></li>
            <li> <Link to="/WISbot">WISbot <i></i></Link></li>
            <li> <Link to="/WISserch">WISsearch <i></i></Link></li>
            <li> <Link to="/WISvec">WISvec <i></i></Link></li>
            <li> <Link to="/WISrag">WISrag <i></i></Link></li>
            <li> <Link to="/WISdoc">WISdoc <i></i></Link></li>
            <li> <Link to="/WISscrap">WISscrap <i></i></Link></li>
            <li> <Link to="/WISocr">WISocr <i></i></Link></li>
            <li> <Link to="/WISvoice">WISvoice <i></i></Link></li>
            <li> <Link to="/WISvision">WISvision <i></i></Link></li>
          </ul>
        </section>
        
        <section className="aiCont">
          <h4 className="title ">
          <span>WISaicc 이란?</span>
        </h4>
        <div className="textWrap">
            <div className="ai-ci"><img src={aiImg} alt="WISaicc" /></div>
            <div className="info">
              <p>WISaicc는 AI 기술을 접목하여 고객 상담 업무를 자동화하고, 상담사 역량을 보조하며, 콜센터 운영 효율과 고객 만족도를 극대화하는 AI 컨택센터 솔루션입니다. 음성인식(STT), 음성합성(TTS), 자연어 이해(NLU), 대화 시나리오 처리, RPA 연동 등의 기능을 통합하여 24시간 365일 고객응대가 가능하고, 상담 품질 관리와 데이터 분석까지 지원합니다.</p>

              <ul className="list">
                <li>
                  <p className="tit">실시간 음성 인식(STT)과 음성 합성(TTS)</p>
                  <p className="txt">고객 음성을 텍스트로 변환하고, AI 음성으로 자연스러운 답변 및 안내를 실시간 제공</p>
                </li>
                 <li>
                  <p className="tit">자연어 이해(NLU) 및 대화 시나리오 처리</p>
                  <p className="txt">고객 문의 의도 파악, 다중 의도 인식, 감정분석을 통해 맞춤형 상담 시나리오를 실행하며, 고객 문의를 정확히 분류해 처리</p>
                </li>
                 <li>
                  <p className="tit">음성봇과 상담사 어드바이저 기능</p>
                  <p className="txt">AI 음성봇이 단순·반복 상담을 자동 응대하고, 복잡한 문의는 상담사에게 대응 스크립트와 실시간 상담 지원을 제공</p>
                </li>
                 <li>
                  <p className="tit">다채널 고객 응대</p>
                  <p className="txt">전화, 채팅, 이메일, SNS 등 다양한 채널을 통합 지원하여 고객 접점 확대와 업무 일관성을 실현</p>
                </li>
                <li>
                  <p className="tit">통화 녹취 및 감정 분석</p>
                  <p className="txt">상담 내용을 기록 및 분석하여 고객 감정을 파악하고 상담 품질 향상, 리스크 관리에 활용</p>
                </li>
                <li>
                  <p className="tit">RPA 연계 자동화</p>
                  <p className="txt">반복 업무나 후처리 작업을 프로세스 자동화와 연결, 상담 효율을 크게 증대</p>
                </li>
              </ul>
            </div>
        </div>
        </section>

        <section className="aiCont">
          <h4 className="title ">
            <span>특장점</span>
          </h4>
          <ul className="textWrap feature-list">
            <li>
              <span className="icon"><img src={aiIcon01} alt="인공지능 학습 기반 지속 개선"/></span>
              <p className="tit">인공지능 학습 기반<br /> 지속 개선</p>
              <p className="txt">실제 고객 대화 데이터를 학습하여 AI의 성능과 대응 정확도를 꾸준히 향상 시킴</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon02} alt="자동 상담사 지원 및 업무 최적화"/></span>
              <p className="tit">자동 상담사 지원 <br />및 업무 최적화</p>
              <p className="txt">실시간 상담 , 고객 이력 조회, 관련 문서 추천 등으로 상담사의 업무 효율과 품질을 높임</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon03} alt="다중 의도 파악"/></span>
              <p className="tit">다중 의도<br />파악</p>
              <p className="txt">고객의 질문 의도를 정확히 인식하여 상담 몰입도 향상</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon04} alt="24시간 무인 상담 가능"/></span>
              <p className="tit">24시간 무인 <br />상담 가능</p>
              <p className="txt">AI 음성봇이 주간·야간 가리지 않고 기본 문의를 처리, 고객 대기 시간 감소 및 서비스 연속성 보장</p>
            </li>
          </ul>
        </section>
        <section className="aiCont">
          <h4 className="title ">
            <span>아키텍처</span>
          </h4>
          <ul className="textWrap ac-list">
              <li>
                <p className="tit">고객 음성·채팅 입력 접수</p>
              </li>
              <li>
                <p className="tit">STT 및 텍스트 전환</p>
              </li>
              <li>
                <p className="tit">NLU 기반 자연어 이해 및 의도 분석</p>
              </li>
              <li>
                <p className="tit">대화 시나리오 처리 및 대응 생성</p>
              </li>
              <li>
                <p className="tit">RPA 및 상담사 연동</p>
              </li>
              <li>
                <p className="tit">통화 녹취·분석 및 품질 모니터링</p>
              </li>
            </ul>
        </section>

        <section className="aiCont">
          <h4 className="title">
            <span>프레임워크</span>
          </h4>
          <div className="textWrap framework">
              <img src={fwImg} alt="WISaicc 프레임워크" onClick={imgClick} />
          </div>
          
        </section>

        <section className="aiCont">
          <h4 className="title">
            <span>활용사례</span>
          </h4>
          <ul className="textWrap case-list">
              <li>
                <p className="tit">고객 상담 업무 자동화 및 효율화</p>
                <p className="txt">AI 음성봇이 단순·반복 상담을 자동 응대하고, 복잡한 문의만 전문 상담사에게 연결</p>
              </li>
                <li>
                <p className="tit">금융권 및 보험사 콜센터</p>
                <p className="txt">은행, 보험사 등에서 투자상품 상담, 고객 문의 처리에 AI 음성봇 활용</p>
              </li>
                <li>
                <p className="tit">여행 및 서비스 업종 고객 지원</p>
                <p className="txt">인바운드/아웃바운드 상담 자동화<br/> 실시간 대응, 예약 관리, 서비스 안내 자동화</p>
              </li>
                <li>
                <p className="tit">소매업 및 프랜차이즈 매장 고객응대</p>
                <p className="txt">매장 전화 응대, 주문 접수, 방문 예약 등 자동화<br/> 24시간 매장 지원으로 운영 효율성 극대화</p>
              </li>
               <li>
                <p className="tit">공공기관 및 대기업의 고객 서비스</p>
                <p className="txt">민원 안내, 정보 제공, 정책 문의 자동화 및 상담 기록 분석</p>
              </li>
               <li>
                <p className="tit">통신사들의 AICC 전략과 확장</p>
                <p className="txt">주요 통신사들은 AI 중심 고객센터를 구축해 다양한 AI 기능을 적용, AI 콜센터 시장을 선도</p>
              </li>
          </ul>
          
        </section>

        <section className="aiCont">
          <div className="btnWrap">
            <button type="button" className="inquiry-btn" onClick={downloadFile}>브로슈어 다운로드</button>
          </div>
        </section>
        
        
			</section>
		</main>
	<Footer />

        </>
    )
}

export default WISaicc;